"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _web = require("@react-spring/web");
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _layout = require("../layout");
var _liveAnnouncer = require("../live-announcer");
var _utils = require("../utils");
var _MessageBannerDismissButton = _interopRequireDefault(require("./MessageBannerDismissButton"));
var _constants = require("./constants");
var _helperComponents = require("./helperComponents");
var _interfaces = require("./interfaces");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MessageBannerWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    'aria-live': ariaLive,
    autoDismissAfter,
    children,
    contentWrapperProps,
    dismissButtonAltText = _constants.MessageBannerDefaultProps.dismissButtonAltText,
    dismissButtonAriaDescribedby,
    icon: providedIcon,
    iconAltText,
    isDismissible,
    onDismissed,
    titleText,
    hasRoundedCorners = _constants.MessageBannerDefaultProps.hasRoundedCorners,
    type = _constants.MessageBannerDefaultProps.type,
    ...forwardedProps
  } = _ref;
  const [isVisible, setIsVisible] = (0, _react.useState)(true);
  const rowRef = (0, _react.useRef)(null);
  const Icon = _constants.MessageBannerTypeIcons[type];
  const backgroundColor = _constants.MessageBannerTypeColors[type];
  const borderColor = _constants.MessageBannerBorderColors[type];
  const iconColor = _constants.MessageBannerIconColors[type];
  const transitions = (0, _web.useTransition)(isVisible, {
    from: {
      opacity: 1
    },
    enter: {
      opacity: 1
    },
    leave: [{
      opacity: 0
    }, {
      height: 0
    }],
    onDestroyed: () => !!onDismissed && onDismissed()
  });
  const [isMouseFocus, setIsMouseFocus] = (0, _react.useState)(false);
  const handleMouseDown = e => {
    const wrapperRef = ref || rowRef;
    if (wrapperRef.current && wrapperRef.current.contains(e.target)) {
      // Used to prevent visually focusing the banner on mouse click.
      setIsMouseFocus(true);
    }
  };
  const handleOnBlur = e => {
    const wrapperRef = ref || rowRef;
    // Reset mouse focus unless internal elements had focus before.
    if (wrapperRef.current && !wrapperRef.current.contains(e.relatedTarget)) {
      setIsMouseFocus(false);
    }
  };
  if (autoDismissAfter && autoDismissAfter < _constants.MINIMUM_DISMISS_TIMEOUT) {
    throw new Error('Auto dismiss time must be greater than or equal to 20000ms');
  }
  (0, _react.useEffect)(() => {
    let timeout;
    if (autoDismissAfter && isVisible) {
      timeout = window.setTimeout(() => {
        setIsVisible(false);
      }, autoDismissAfter);
    }
    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [isVisible, autoDismissAfter]);
  const titleTextId = (0, _react.useMemo)(() => titleText ? (0, _utils.getUniqueId)('message-banner-title-') : undefined, [titleText]);
  const dismissButtonAriaDescribedbyValue = dismissButtonAriaDescribedby !== null && dismissButtonAriaDescribedby !== void 0 ? dismissButtonAriaDescribedby : titleTextId;
  return transitions((styles, item) => item && (0, _react2.jsx)(_web.animated.div, {
    style: styles
  }, (0, _react2.jsx)(_helperComponents.MessageBannerRow, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    isMouseFocus: isMouseFocus,
    hasRoundedCorners: hasRoundedCorners,
    onBlur: handleOnBlur,
    onMouseDown: handleMouseDown,
    ref: ref || rowRef,
    tabIndex: -1
  }), (0, _react2.jsx)(_liveAnnouncer.LiveRegion, {
    role: _liveAnnouncer.LiveRegionRole.Status
    // Only announce if visible (when it appears), otherwise it would announce when dismissing
    ,
    "aria-live": ariaLive && isVisible ? ariaLive : 'off'
  }, (0, _react2.jsx)(_helperComponents.MessageBannerIconWrapper, {
    color: iconColor
  }, providedIcon || (0, _react2.jsx)(Icon, {
    title: iconAltText || _constants.MessageBannerDefaultAltTexts[type]
  })), (0, _react2.jsx)(_layout.View, contentWrapperProps, titleText && (0, _react2.jsx)(_react.default.Fragment, null, (0, _react2.jsx)(_helperComponents.MessageBannerText, {
    dataTestComponent: "MessageBannerTitle",
    id: titleTextId
  }, (0, _react2.jsx)("strong", null, titleText)), (0, _react2.jsx)(_layout.Spacer, {
    width: 8,
    display: "inline-block"
  })), (0, _react2.jsx)(_helperComponents.MessageBannerText, {
    dataTestComponent: "MessageBannerContent"
  }, children))), isDismissible && (0, _react2.jsx)(_react.default.Fragment, null, (0, _react2.jsx)(_layout.Spacer, {
    flex: 1
  }), (0, _react2.jsx)(_helperComponents.MessageBannerIconWrapper, null, (0, _react2.jsx)(_MessageBannerDismissButton.default, {
    "aria-describedby": dismissButtonAriaDescribedbyValue,
    iconAltText: dismissButtonAltText,
    setIsVisible: setIsVisible
  }))))));
});
const MessageBannerWithDocs = (0, _stencilReactDesc.describe)(MessageBannerWithoutDocs).description('Banner used for alert style messages.');
MessageBannerWithDocs.defaultProps = {
  ..._constants.MessageBannerDefaultProps
};
MessageBannerWithDocs.propTypes = {
  'aria-live': _stencilReactDesc.PropTypes.oneOf(['polite', 'assertive', 'off']).description('Sets "aria-live" on the message banner.'),
  autoDismissAfter: _stencilReactDesc.PropTypes.number.description('Amount of time after which the component will automatically dismiss, in milliseconds.'),
  children: _stencilReactDesc.PropTypes.node.isRequired.description('Main content to display in the banner.'),
  dismissButtonAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the "dismiss" button.'),
  dismissButtonAriaDescribedby: _stencilReactDesc.PropTypes.string.description('Sets "aria-describedby" on the "dismiss" button. As default this will be set to the titleText ID if titleText is defined.'),
  icon: _stencilReactDesc.PropTypes.node.description('Icon to display on the leading side of the message banner.').deprecated('This property is deprecated, and will not be supported after 4.x.'),
  iconAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the icon displayed on the leading side of the banner. The text should be tailored to the type of banner.'),
  isDismissible: _stencilReactDesc.PropTypes.bool.description('Adds a "dismiss" button to the banner which hides the banner.'),
  onDismissed: _stencilReactDesc.PropTypes.func.description('Function called once the message banner has finished dismissing after the dismiss button has been clicked.').format('() => void'),
  titleText: _stencilReactDesc.PropTypes.string.description('Title text to display in the banner before the main content.'),
  type: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.MessageBannerType)).description('The type of message being displayed in the banner. Affects the visual style of the banner.'),
  hasRoundedCorners: _stencilReactDesc.PropTypes.bool.description('Whether the component should have rounded corners. You can turn it off when the component is outside of the content grid and full width.')
};
const MessageBanner = (0, _utils.withTestAttributes)({
  component: 'StencilReactMessageBanner'
})(MessageBannerWithDocs);
MessageBanner.displayName = 'MessageBanner';
var _default = exports.default = MessageBanner;